import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& > img': { opacity: 1, transition: 'opacity var(--motion-duration-feedback, 0ms) ease-out' },
    '&[data-state="copied"] > img': { opacity: 0 },
    '&[data-state="copied"] > svg': { opacity: 1 }
  },
  icon: { width: 24, height: 24 },
  check: {
    position: 'absolute',
    width: 20,
    height: 20,
    opacity: 0,
    color: 'currentColor',
    transition: 'opacity var(--motion-duration-feedback, 0ms) ease-out'
  },
  status: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    overflow: 'hidden',
    clipPath: 'inset(50%)',
    whiteSpace: 'nowrap'
  }
}));
